import { HStack, Text } from '@chakra-ui/react';
import { IoArrowBackOutline } from 'react-icons/io5';

export const HelivanBackButton = ({
  onClick,
}: {
  onClick: (e?: any) => void;
}) => {
  return (
    <HStack
      onClick={onClick}
      _hover={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: 'black',
      }}
      spacing={1}
      color="#8F8F8F"
      transition="0.2s"
    >
      <IoArrowBackOutline size={16} />
      <Text fontSize="16px" fontWeight={500}>
        back
      </Text>
    </HStack>
  );
};
